import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../models/user';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.development';
import { UserCreationRequest } from '../../requests/user-creation-request';
import { UserVerificationRequest } from '../../requests/user-verification-request';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  public getUsers() : Observable<User[]> {
    return this.http.get<User[]>(`${environment.API_URL}/users`);
  }

  public createUser(request: UserCreationRequest) : Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/users/create`, request);
  }

  public deleteUser(uid: string) : Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/users/delete`, {uid: uid});
  }

  public verifyUser(request: UserVerificationRequest) : Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/users/verify`, request);
  }

  public username(url: string) : Observable<any> {
    return this.http.post<string>(`${environment.API_URL}/users/name`, {url: url});
  }

  public forgottenPassword(email: string) : Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/forgotten-password`, {email: email});
  }

  public updateUser(user: any) : Observable<User> {
    return this.http.post<User>(`${environment.API_URL}/users/update`, user);
  }
}
